import { Component } from '@angular/core';
import { SideBar } from "@shared/components/side-bar/side-bar";
import { Spinner } from "@shared/components/spinner/spinner";
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-main',
  imports: [SideBar, Spinner, RouterOutlet],
  templateUrl: './main.html',
  styleUrl: './main.css',
})
export class Main {}
